export default "__VITE_ASSET__24e1eb77__"